import React from 'react';

const TestimonialVideos = () => {
  const videos = [
    {
      id: 1,
      title: 'Client Testimonial 1',
      url: 'https://www.youtube.com/embed/VIDEO_ID_1', // Replace with actual YouTube embed URL
    },
    {
      id: 2,
      title: 'Client Testimonial 2',
      url: 'https://www.youtube.com/embed/VIDEO_ID_2',
    },
    {
      id: 3,
      title: 'Client Testimonial 3',
      url: 'https://www.youtube.com/embed/VIDEO_ID_3',
    },
  ];

  return (
    <section style={styles.section}>
      <h2 style={styles.heading}>What Our Clients Say</h2>
      <div style={styles.videoGrid}>
        {videos.map((video) => (
          <div key={video.id} style={styles.videoWrapper}>
            <iframe
              width="100%"
              height="100%"
              src={video.url}
              title={video.title}
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              style={styles.iframe}
            ></iframe>
          </div>
        ))}
      </div>
    </section>
  );
};

const styles = {
  section: {
    background:'#f1e7e7',
    padding: '40px 20px',
    backgroundColor: '#f9f9f9',
    textAlign: 'center',
  },
  heading: {
    fontSize: '2rem',
    marginBottom: '30px',
    color: '#000',
  },
  videoGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
    gap: '20px',
    justifyContent: 'center',
  },
  videoWrapper: {
    position: 'relative',
    paddingBottom: '56.25%', // 16:9 aspect ratio
    paddingTop: 0,
    height: 0,
    overflow: 'hidden',
    borderRadius: '12px',
    boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
  },
  iframe: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    border: 'none',
  },
};

export default TestimonialVideos;
